import { grid } from 'styled-system';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { DynamicFormInput } from '../../dynamic-form-input';
import { LabelledInput } from '../../labelled-input';
import { useHydrateItem } from '../../../hooks/use-hydrate-item';

const ItemForm = ({ activeItem }) => {
  useHydrateItem(activeItem ? { skuDetails: [activeItem] } : null);

  // TODO: this array is shared between the form and the table; might make sense to share somewhere
  const skuFields = ['sku', 'batch', 'skuDescription', 'condition', 'useByDate', 'pallets', 'stock', 'inStock'];

  return skuFields.map((field) => (
    <DynamicFormInput
      key={field}
      name={field}
      render={(props) => (
        <Cell gridColumn="span 2">
          <LabelledInput {...props} />
        </Cell>
      )}
    />
  ));
};

ItemForm.propTypes = {
  activeItem: PropTypes.shape(),
};

ItemForm.defaultProps = {
  activeItem: null,
};

const Cell = styled.div`
  ${grid};
  align-self: center;
`;

export { ItemForm };
